import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';
import { Rules } from '../model/types';

export const cardRulesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCardRules: build.query<
      ApiResponse<Record<Rules, 'false' | 'true'>>,
      { accountId: string; cardId: string }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/rules`,
        method: 'GET'
      })
    }),
    setCardRule: build.mutation<
      ApiResponse<unknown>,
      { accountId: string; cardId: string; name: Rules; value: 0 | 1 }
    >({
      query: ({ accountId, cardId, name, value }) => ({
        url: `private/river/${accountId}/card/${cardId}/set-rule`,
        method: 'POST',
        body: { name, value }
      })
    }),
    closeCard: build.mutation<ApiResponse<unknown>, { accountId: string, cardId: string }>({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/close`,
        method: 'POST',
      }),
    })
  })
});

export const { useGetCardRulesQuery, useSetCardRuleMutation, useCloseCardMutation } = cardRulesApi;
